import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";
const Ecard = () => {
  const message = encodeURIComponent("Hi"); // URL-encoded message

  return (
    <>
      <div className="bg_image bg-opacity-0 min-h-screen flex items-center justify-center shadow-lg  max-w-full md:max-w-full w-full">
        <div className="p-8">
          <div className="backdrop-blur-sm bg-white/30">
            <div className="p-4 py-5">
              <div className="space-y-1 text-center mb-10">
                <Link to={"https://vineshprints.com/"} target="_blank">
                  <div className="w-48 mx-auto">
                    {/* <img src={vikasLogo2} alt="logo" className="object-cover my-auto" /> */}
                    <img
                      src="/image/Vinesh_logo.png"
                      alt="Vinesh"
                      className="object-cover my-auto"
                    />
                  </div>
                </Link>
                <h1 className="text-sm font-semibold">
                  VINESH SILK MILLS PRIVATE LIMITED
                </h1>
              </div>
              <div className="mb-14">
                <p className="text-[0.68em] text-center leading-normal p-1.5 font-medium">
                  WE ARE LEADING DIGITAL TEXTILE PRINTING COMPANY DEDICATED TO
                  TRANSFORMING IDEAS INTO VIBRANT, HIGH-QUALITY TEXTILE DESIGNS.
                  WITH OUR STATE-OF-THE-ART TECHNOLOGY AND COMMITMENT TO
                  INNOVATION, WE BRING YOUR IMAGINATION TO LIFE ON FABRIC.
                </p>
              </div>
              <div className="text-center mb-10 ">
                <div className="space-y-5 ">
                  <Link
                    to={`https://wa.me/918905678961?text=${message}`}
                    className="flex items-center justify-center"
                  >
                    <FaWhatsapp size={26} className="text-[#25D366]" />
                    <span className="ml-2 text-sm font-semibold">
                      ATUL JAIN +91 89056 78961
                    </span>
                  </Link>
                  <Link
                    to={`https://wa.me/919099107104?text=${message}`}
                    className="flex items-center justify-center"
                  >
                    <FaWhatsapp size={26} className="text-[#25D366]" />

                    <span className="ml-2 text-sm font-semibold">
                      SIDDHANT JAIN +91 90991 07104
                    </span>
                  </Link>
                </div>
              </div>
              <div className=" text-center text-[0.73em] font-medium mb-5">
                <p className="">
                  SHED NO 35, GANESH INDUSTRIAL CO-OP SERVICE SOCIETY,UDHNA
                  MAGDALLA ROAD , SURAT - 395017
                </p>
              </div>
              <div className="text-center text-base mb-2">
                <Link to={"https://vineshprints.com/"} target="_blank">
                  www.vineshprints.com
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="p-4">
          <div className="p-2 backdrop-blur-md bg-white/50 border border-gray-300 rounded-sm">
            <h1 className="text-center text-xs capitalize">
              Manufacturers, Exporters, Importers of
              <p className=" font-semibold text-base">
                Fancy Dyed Saree & Dress Materials
              </p>
            </h1>
          </div>
        </div> */}

        {/* <div className="absolute  bottom-[12%] left-0 right-0 flex items-center justify-center mx-auto my-2">
          <Link
            to={`https://wa.me/${phoneNumber}?text=${message}`}
            type="button"
            className="text-[#eee] ripple-green text-sm flex items-center justify-center gap-2 bg-[#25D366] font-bold p-4 rounded-full hover:bg-[#2cb75f] capitalize"
          >
            <FaWhatsapp size={26} />
          </Link>
        </div> */}
      </div>
    </>
  );
};

export default Ecard;
